import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';

const Fondements = () => {
  const { t } = useTranslation();

  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionTitle 
          overline={t('about.foundations.title')}
          highlight=""
          separatorColor="socabeg-blue"
          showLogo={true}
        />

        {/* Section Vision, Missions, Objectifs avec icônes */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-16">
          {/* Vision */}
          <motion.div 
            className="flex flex-col items-center text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="mb-4">
              <img src="/icons/vision-icon.svg" alt="Vision" className="w-24 h-24" />
            </div>
            <h3 className="text-xl font-bold mb-4">{t('about.engagement.vision.title')}</h3>
            <p className="text-gray-700 text-justify">
              {t('about.engagement.vision.paragraph1')}
            </p>
          </motion.div>

          {/* Missions */}
          <motion.div 
            className="flex flex-col items-center text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="mb-4">
              <img src="/icons/mission-icon.svg" alt="Missions" className="w-24 h-24" />
            </div>
            <h3 className="text-xl font-bold mb-4">{t('about.engagement.mission.title')}</h3>
            <p className="text-gray-700 text-justify">
              {t('about.engagement.mission.paragraph1')}
            </p>
          </motion.div>

          {/* Objectifs */}
          <motion.div 
            className="flex flex-col items-center text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="mb-4">
              <img src="/icons/objectifs-icon.svg" alt="Objectifs" className="w-24 h-24" />
            </div>
            <h3 className="text-xl font-bold mb-4">{t('about.engagement.objectives.title')}</h3>
            <p className="text-gray-700 text-justify">
              {t('about.engagement.objectives.paragraph1')}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Fondements;
